<template>
    <app-layout>
        <div class="is-clearfix">
            <h1 class="title is-pulled-left">Teams list</h1>
            <user-avatar class="is-pulled-right"/>
            <team-create @created="load" class="is-pulled-right"/>
        </div>

        <team-list
            v-if="!list.loading"
            @removed="load"
            @updated="load"
            :teams="list.data.results || []"
            :total-count="list.data.count || 0"/>

        <teams-skeleton v-else/>
    </app-layout>
</template>

<script>
import { mapState } from 'vuex';
import TeamList from '../components/team/TeamList.vue';
import TeamCreate from '../components/team/TeamCreate.vue';
import AppLayout from '../components/layouts/AppLayout.vue';
import TeamsSkeleton from '../components/skeletons/TeamsSkeleton.vue';
import UserAvatar from '../components/user/UserAvatar.vue';
import { set_title } from '../utils/helpers';

export default {
    name: 'Teams',
    components: {
        UserAvatar, TeamsSkeleton, AppLayout, TeamList, TeamCreate,
    },
    computed: mapState('teams', ['list']),
    created() {
        this.load();
        set_title('Spaces list');
    },
    watch: {
        $route: 'load',
    },
    methods: {
        load() {
            this.$store.dispatch('teams/list', { page: this.$route.query.page || 1 });
        },
    },
};
</script>
